module.exports = __webpack_public_path__ + "img/sixteen.72f023bb.png";